/**
 * 基础文档静态路由数据
 * */

export default {
  path: '/basicDoc',
  name: 'basicDoc',
  component: () => import('@/views/index/components/basicDoc/index.vue'),
  meta: {
    unrequireLogin: true
  }
}
